import * as React from 'react'
export const YoutubeIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1739_1782)'>
        <path
          d='M19.5938 5.1875C19.375 4.3125 18.6875 3.65625 17.8125 3.40625C16.25 3 10 3 10 3C10 3 3.75 3 2.1875 3.40625C1.3125 3.625 0.65625 4.3125 0.40625 5.1875C0 6.75 0 10 0 10C0 10 0 13.25 0.40625 14.8125C0.625 15.6875 1.3125 16.3438 2.1875 16.5938C3.75 17 10 17 10 17C10 17 16.25 17 17.8125 16.5938C18.6875 16.375 19.3438 15.6875 19.5938 14.8125C20 13.25 20 10 20 10C20 10 20 6.75 19.5938 5.1875ZM8 13V7L13.1875 10L8 13Z'
          fill='current'
        />
      </g>
      <defs>
        <clipPath id='clip0_1739_1782'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
